import React from 'react';
import Hero from '../components/home/Hero';
import ServicesGrid from '../components/home/ServicesGrid';
import HowItWorks from '../components/home/HowItWorks';
import TransparencySection from '../components/home/TransparencySection';
import Testimonials from '../components/home/Testimonials';
import CoverageMap from '../components/home/CoverageMap';
import DriverCTA from '../components/home/DriverCTA';
import Footer from '../components/common/Footer';
import WhatsAppFloat from '../components/common/WhatsAppFloat';

const HomePage = () => {
  return (
    <main className="home">
      <Hero />
      <ServicesGrid />
      <HowItWorks />
      <TransparencySection />
      <Testimonials />
      <CoverageMap />
      <DriverCTA />
      <Footer />
      <WhatsAppFloat />
    </main>
  );
};

export default HomePage;
